import styled from 'styled-components';
import { Flex, Typography } from 'antd';

export const Title = styled(Typography.Title)`
    margin: 0 !important;
`;

export const Field = styled(Flex)`
    max-width: 630px;
`;
